export function videoBtns(){

    $(document).ready(function(){
        

        runCounter();

        jQuery('#main_video').currentTime = 0;
        $(".play").click(function(){
            $(".play").hide();
            $(".stop").show();
            if($(".stop").hasClass("active")){
                jQuery('#main_video').currentTime = 0;
            }
            jQuery('#main_video').get(0).play();                                         
        });
        $(".stop").click(function(){
            $(".play").show();
            $(".stop").hide();
            $(".stop").addClass("active");
            jQuery('#main_video').get(0).pause();                                         
        });
      
    });	 
}


function runCounter(){
    $('.comp1 .content-comp1 .comp1bottom .thirds .third span.third_value span').each(function () {
        var $this = $(this);


        // $('.comp2 .clicked').css('pointer-events','none');
        if($this.text().indexOf('.') != -1){
            if($this.text().replace(',','') > 0){
                $({ Counter: 0 }).animate({ Counter: $this.text().replace(',','') }, {
                    duration: 1000,
                    easing: 'swing',
                    step: function () {
                        $this.text(this.Counter.toFixed(1));
                    },
                    complete: function() {
                        var number = this.Counter.toFixed(1);
                        var parts = number.toString().split(".");
                        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        $this.text(parts.join(".").replace(/(\.\d*?[1-9])0+$/g, "$1" ));
                        // $('.comp2 .clicked').css('pointer-events','auto');
                    }
                }); 
            }
        }
        else{
            if($this.text().replace(',','') > 0){
                $({ Counter: 0 }).animate({ Counter: $this.text().replace(',','') }, {
                    duration: 1000,
                    easing: 'swing',
                    step: function () {
                    $this.text(Math.ceil(this.Counter));
                    },
                    complete: function() {
                        var number = this.Counter;
                        $this.text(number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                        // $('.comp2 .clicked').css('pointer-events','auto');
                    }
                });
            }

            else if($this.text().replace('’','') > 0){
                $({ Counter: 0 }).animate({ Counter: $this.text().replace('’','') }, {
                    duration: 1000,
                    easing: 'swing',
                    step: function () {
                    $this.text(Math.ceil(this.Counter));
                    },
                    complete: function() {
                        var number = this.Counter;
                        $this.text(number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "’"));
                        // $('.comp2 .clicked').css('pointer-events','auto');
                    }
                });
            }
        }
        
    });
   }